// stores/appStore.ts
import { defineStore, acceptHMRUpdate } from 'pinia';

export const useAppStore = defineStore('store', {
    state: () => ({
        deviceType: 'Desktop',
        // auth
        isAuthenticated: null as boolean | null,   // null = unknown, true/false = known
        userId: null as number | null,
        role: null as string | null,
        isSuspended: null as boolean | null,
        suspendedReason: null as string | null,
        suspendedAt: null as string | null,

        // prefs
        currentTheme: 'system',
        mixedTheme: true,
        mainDrawerDefault: false,
        rememberMe: false,
        globalFont: 'Inter',
        layoutVertical: true,
        backgroundTheme: 'foxBackgrounds',
        wipNotice: true,
        cookieNotice: true,
        balancePrivacy: false,
        sensitivityMode: false,
        debugging: false,

        // dashboard
        dialRefresh: 30,
        timeframe: 'hour',
        secondsUntilRefresh: 60,
        overviewChart: 'cpu',
    }),
    persist: true,
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
}
